import { cn } from '@theprintbar/shared';
import { HTMLProps } from 'react';
import { useFormContext } from 'remix-validated-form';

export function GlobalError({ className, ...props }: HTMLProps<HTMLParagraphElement>) {
	const { fieldErrors } = useFormContext();

	const globalError = fieldErrors['global-error'];

	return globalError ? (
		<p {...props} className={cn('text-red text-xs h-6 flex items-center')}>
			{globalError}
		</p>
	) : null;
}
